<template>
  <div class="animate-pulse flex flex-col justify-between">
    <div :class="['rounded-lg w-full h-full', background || 'bg-gray-300 dark:bg-zinc-800']"></div>
  </div>
</template>

<script setup>
const props = defineProps({
  background: {
    type: String,
    default: null,
  },
});
</script>

<style scoped>
/* Add any necessary styles here, or ensure this section is empty if not needed */
</style>
